const state = {
    isOpen: null,
    messageDataDefault: {},
    messageData: {},
};

const actions = {
    // Если ({commit}) записать без скобок, то Нетбинса показывает ошибку
    openMessageBox: ({commit}, messageData) => {
        commit('setMessageBoxParams', messageData);
        if (typeof BX24 !== 'undefined') {
            BX24.scrollParentWindow(0, () => {
                commit('setMessageBoxIsOpen', true);
            });
        } else {
            commit('setMessageBoxIsOpen', true);
        }
    },
    closeMessageBox: ({commit}) => {
        commit('setMessageBoxIsOpen', false);
    },
}

const mutations = {
    setMessageBoxParams(state, messageData) {
        state.messageData = {};
        Object.assign(state.messageData, state.messageDataDefault, messageData);
    },
    setMessageBoxDefault(state, messageData) {
        state.messageDataDefault = messageData;
        state.messageData = messageData;
        state.isOpen = false;
    },
    setMessageBoxIsOpen(state, isOpen) {
        state.isOpen = isOpen;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
